import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brand-features',
  templateUrl: './brand-features.component.html',
  styleUrls: ['./brand-features.component.css']
})
export class BrandFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/brand-features/brand-features.component.ts